var _circle, _circle2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAuthorVerified = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  fill: "#FD0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6.5,
  stroke: "#222",
  strokeOpacity: 0.1
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1.921,
  height: 7.683,
  x: 9.337,
  y: 3,
  fill: "#222",
  rx: 0.96,
  transform: "rotate(30 9.337 3)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4.802,
  height: 1.921,
  x: 3.96,
  y: 6.55,
  fill: "#222",
  rx: 0.96,
  transform: "rotate(30 3.96 6.55)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthorVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/author_verified.78b4aa3bf0d87c67d991353f9ccc0538.svg";